import React, {ReactNode} from 'react';
import {Link} from 'react-router-dom';

import {useAlertFrequencyTypes} from 'src/hooks/dictionaries/useAlertDictionaries';
import {AlertFrequencyType} from 'src/openapi/admin/models/AlertFrequencyType';

import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';
import {Integer} from '@pb/kit-component-formatters';
import Group from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';
import Loading from '@pb/kit-component-loading';
import {Cell, Row} from '@pb/kit-component-table';
import {useShown} from '@pb/kit-hooks-use-shown';

import {AlertDetailsModal} from '../alerts/alert-details-modal';

import {SavedTableTimestampCell} from './saved-table-time-cell';

import type {TableSavedSearch} from '../typedef';


type Props = {
    showZebra: boolean,
    search: TableSavedSearch,
    userId: number,
    isLoading: boolean,
    alertsLoading: boolean,
};

export const RequestItem = (props: Props) => {
    const {
        search,
        showZebra,
        userId,
        isLoading,
        alertsLoading,
    } = props;

    const {
        createdAt, lastRunAt, lastSharedAt, lastUpdatedAt, name, alertCount, searchTotalCount, alert,
        searchTypeCode, savedItemType,
    } = search;

    const {shown, onClick, onClose} = useShown();
    const {getAlertFrequencyTypeByCode} = useAlertFrequencyTypes();

    const isAlertNone = alert === AlertFrequencyType.NONE;

    let searchTotalCountContent: ReactNode = null;
    if (isLoading) {
        searchTotalCountContent = <Loading type="ICON"/>;
    } else if (searchTotalCount) {
        searchTotalCountContent = <Integer value={searchTotalCount}/>;
    }

    let alertCountContent: ReactNode = null;
    if (isLoading) {
        alertCountContent = <Loading type="ICON"/>;
    } else if (!isAlertNone) {
        alertCountContent = <Integer value={alertCount}/>;
    }

    const renderAlertCell = () => {
        if (savedItemType === 'Deal') {
            return '--';
        }

        return (
            <>
                <Link to="#" onClick={onClick}>
                    <Group alignItems="center">
                        {isAlertNone
                            ? (<Icon type={Icons.BELL_LIGHT}/>)
                            : (<Icon type={Icons.BELL}/>)}
                        {getAlertFrequencyTypeByCode(alert || '')?.description || '--'}
                    </Group>
                </Link>
                {shown ? (
                    <AlertDetailsModal
                        contentId={'' + search.id}
                        alertTypeCode={searchTypeCode}
                        title={name}
                        isOpen={shown}
                        onClose={onClose}
                        userId={userId}
                    />
                ) : null}
            </>
        );
    };

    const alertCellContent: ReactNode = alertsLoading ? <Loading type="ICON"/> : renderAlertCell();

    return (
        <Row showZebra={showZebra}>
            <Cell>
                <EllipsisTextHint title={name}>{name}</EllipsisTextHint>
            </Cell>
            <Cell>
                <EllipsisTextHint title={savedItemType}>{savedItemType}</EllipsisTextHint>
            </Cell>
            <Cell>
                <SavedTableTimestampCell timestamp={createdAt}/>
            </Cell>
            <Cell>
                <SavedTableTimestampCell timestamp={lastRunAt}/>
            </Cell>
            <Cell>
                <SavedTableTimestampCell timestamp={lastSharedAt}/>
            </Cell>
            <Cell>
                <SavedTableTimestampCell timestamp={lastUpdatedAt}/>
            </Cell>
            <Cell>
                {alertCellContent}
            </Cell>
            <Cell>
                {searchTotalCountContent}
            </Cell>
            <Cell>
                {alertCountContent}
            </Cell>
        </Row>
    );
};
